import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Header } from 'datastake-daf/dist/components';
import { useLocation, useNavigate } from 'react-router-dom';
import AIQuery from './components/AIQuery';
import Entities from './components/Entities';
import Locations from './components/Locations';
import { useFindInformation } from './store';
import Style from '../../components/Forms/locations/style';
import { renderBreadCrumbs } from '../../helpers/breadCrumbs';

export default function FindInformation({ mod }) {
  const goTo = useNavigate();
  const { t } = useTranslation();
  const location = useLocation();
  const { defaultTab, setDefaultTab } = useFindInformation();
  const params = useMemo(() => new URLSearchParams(location.search), [location.search]);
  const activeTab = useMemo(() => defaultTab || params.get('activeTab') || 'locations', [params, defaultTab]);

  const setActiveTab = useCallback((tab) => {
    goTo(`${location.pathname}?activeTab=${tab}`);
    setDefaultTab(tab);
  }, [goTo, location]);

  const breadCrumbs = useMemo(() => {
    return renderBreadCrumbs({ t, view: 'find-information', isDataStore: true, goTo, mod });
  }, [t, goTo, mod]);

  return (
    <Style className="semibold form-input-output">
      <Header
        breadcrumbs={breadCrumbs}
        title={t('Find Information')}
        supportText={t('Identify available information sources among users of Datastake applications or other databases connected to the platform.')}
      />
      {/* <Tabs activeTab={activeTab} setActiveTab={setActiveTab} /> */}

      {activeTab === 'locations' && (
        <Locations mod={mod} activeTab={activeTab} setActiveTab={setActiveTab} />
      )}

      {activeTab === 'entities' && (
        <Entities mod={mod} activeTab={activeTab} setActiveTab={setActiveTab} />
      )}

      {activeTab === 'aiQuery' && (
        <AIQuery mod={mod} />
      )}
    </Style>
  )
}
